import { atom } from 'jotai';

/** Persistent: OS reports selected capture endpoint muted / ~0% volume. */
export const preStartSystemMuteUnhealthyAtom = atom(false);

/** Dismissible mic-pill popover (badge stays while unhealthy). */
export const preStartSystemMutePopoverOpenAtom = atom(false);
